import { HashimotoTestEdge } from '@front-activerse/common-components';
import { HashimotoTestMeasurementFieldEnum } from '../types';

const createMeasurements = (
  hashimotoTestHistory: HashimotoTestEdge[],
  type: HashimotoTestMeasurementFieldEnum
) => {
  return hashimotoTestHistory
    .filter((test) => test.node[type] !== null)
    .map((el) => ({
      id: el.node.id,
      value: el.node[type],
      testedAt: el.node.testedAt,
    }));
};

export default createMeasurements;
